<template>
  <div class="supply">
    <div class="hard">
      <div class="big-title">
        <p>行业痛点</p>
        <div class="line"></div>
        <div class="desc">重视体验服务，全面打造教育品控体系，解决行业痛点</div>
      </div>
      <div class="hard-box">
        <div class="hard-item" v-for="item in systemArr" :key="item.id">
          <img :src="item.img" alt="" />
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <div class="system">
      <div class="big-title">
        <p>核心功能</p>
        <div class="line"></div>
        <div class="desc">
          运用各种特色功能，针对细分场景的教育刚需产品，提供优质的服务体验。
        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="item in hardArr" :key="item.id">
          <img :src="item.img" alt="" />
          <h5>{{ item.title }}</h5>
        </div>
      </div>
    </div>

    <div class="modeValue">
      <div class="big-title">
        <p>核心价值</p>
        <div class="line"></div>
        <div class="desc">向可持续化、效率化、渠道成熟化、趣味化升级发展。</div>
      </div>
      <div class="modeCont">
        <img src="../../static/images/solution/education14.png" alt="" />
        <div class="mode-box">
          <div class="mode-box-after">
            <div v-for="(item, index) in modeList" :key="index">
              <div class="mode-item">
                <img :src="item.img" alt="" />
                <div>
                  <h5>{{ item.title }}</h5>
                  <h6>{{ item.cont }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //核心列表
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/education19.png"),
          title: "视频管理\n",
        },
        {
          id: 1,
          img: require("../../static/images/solution/education5.png"),
          title: "课程分销",
        },
        {
          id: 2,
          img: require("../../static/images/solution/education6.png"),
          title: "优惠劵",
        },
        {
          id: 3,
          img: require("../../static/images/solution/education7.png"),
          title: "课程折扣",
        },
        {
          id: 4,
          img: require("../../static/images/solution/education8.png"),
          title: "数据分析",
        },
        {
          id: 5,
          img: require("../../static/images/solution/education9.png"),
          title: "收益提现",
        },
        {
          id: 6,
          img: require("../../static/images/solution/education10.png"),
          title: "消息推送",
        },
        {
          id: 7,
          img: require("../../static/images/solution/education11.png"),
          title: "评价管理",
        },
        {
          id: 8,
          img: require("../../static/images/solution/education12.png"),
          title: "课程推荐",
        },
        {
          id: 9,
          img: require("../../static/images/solution/education13.png"),
          title: "会员管理",
        },
      ],
      //行业痛点数据
      systemArr: [
        {
          id: 0,
          title: "流量贵",
          desc: "流量红利消失，广告投放成本越来越高",
          img: require("../../static/images/solution/education1.png"),
        },
        {
          id: 1,
          title: "客户散",
          desc: "微信、app、网站、电销客户运营系统众多，客户分散且沉默 ",
          img: require("../../static/images/solution/education2.png"),
        },
        {
          id: 2,
          title: "决策流程长",
          desc: "注册到成交流程繁琐，效率低下，线索浪费",
          img: require("../../static/images/solution/education3.png"),
        },
        {
          id: 3,
          title: "增长乏力",
          desc: "如何赋能地推/销售，甚至是存量客户，突破用户增长瓶颈",
          img: require("../../static/images/solution/education4.png"),
        },
      ],
      modeIndex: 0, //选中的模式
      //模式列表
      modeList: [
        {
          img: require("../../static/images/solution/education15.png"),
          title: "全链路广告效果监测，降低引流成本",
          cont: "整合所有投放渠道数据，完成从流量到转化交易全流程广告效果监测，帮助教育企业了解每一分的投放费用产生的价值，甄别高效投放渠道、创意、关键字等，帮助执行更精准的广告投放，从而降低引流成本。",
        },
        {
          img: require("../../static/images/solution/education17.png"),
          title: "潜客自动化培育与精准营销",
          cont: "可以自定义客户运营流程，基于客户的标签与行为，自动触发针对性的运营跟进流程。打通前后端系统工具，捕捉从注册到成单的行为闭环，识别关键行为，在合适的时机对客户进行转化。",
        },
        {
          img: require("../../static/images/solution/education16.png"),
          title: "对接运营工具，整合全渠道客户数据",
          cont: "用户只需几个点击，即可帮助企业从各类客户触点中取得客户数据，并沉淀下来。",
        },
        {
          img: require("../../static/images/solution/education18.png"),
          title: "裂变营销，激活存量用户",
          cont: "通过成熟的SDK技术，实时追踪裂变全链路数据，帮助企业盘活存量用户，破局用户增长瓶颈，进一步降低客户获取成本。",
        },
      ],
    };
  },
  methods: {
    //立即咨询
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 80px;
}

.hard {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 80px;

  .hard-box {
    display: flex;
    margin: 0 auto;
    width: 1440px;
    justify-content: space-between;
  }

  .hard-item:hover {
    position: relative;
    top: -20px;
  }

  .hard-item {
    box-sizing: border-box;
    width: 332px;
    height: 332px;
    background: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);

    img {
      width: 80px;
      height: 80px;
      margin: 60px 0 36px 0;
    }

    h2 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }

    p {
      width: 236px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      margin: 23px 0 0 0;
    }
  }
}

.modeValue {
  width: 1400px;
  margin: 81px auto;
}

.modeCont {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 27px;

  img {
    width: 525px;
    height: 488px;
  }

  .mode-box {
    position: absolute;
  }

  .mode-box-after {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
  }

  .mode-box-after {
    margin: 49px auto 95px;
    width: 1300px;
  }

  .mode-item {
    width: 500px;
    padding: 24px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin-bottom: 51px;
    display: flex;
    justify-content: flex-start;

    img {
      width: 28px;
      height: 28px;
      margin: 0 12px 0 0;
    }

    h5 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin: 0 0 22px 0;
    }

    h6 {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }
}

.modeItro {
  display: flex;
  justify-content: flex-start;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin: 30px 0 0 0;

  span {
    width: 70px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    margin: 0 42px 0 0;
  }

  i {
    list-style: none;
    width: 543px;
  }
}

.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;
  border-box: box-sizing;

  .system-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .system-item {
    width: 279px;
    height: 279px;
    background: #FFFFFF;
    border: 1px solid #F5F5F5;
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 0.6);
    text-align: center;

    img {
      width: 52px;
      height: 52px;
      margin: 85px 0 40px 0;
    }

    h5 {
      width: 126px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin: 0 auto;
    }
  }

  .system-item:hover {
    box-shadow: 0px 0px 35px 15px rgba(230, 192, 76, 0.1);
  }
}

.line {
  width: 42px;
  height: 2px;
  background: #FFC000;
  border-radius: 1px;
  margin-top: 29px;
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 50px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionEducation.vue